import { FC } from 'react';
import { LiaCheckDoubleSolid } from 'react-icons/lia';
import { useTheme } from 'styled-components';

import { Button, Typography } from '../../../designComponents';
import { PlansCardStyled } from './styled';

const data = [
  {
    label: '1 to 10 Posters',
  },
  {
    label: 'Select Material Type',
  },
  {
    label: 'Drill Holes',
  },
  {
    label: 'Stainless Steel Bracket Screws',
  },
  {
    label: 'Select A4 or A3',
  },
];

type PlansCardType = {
  isRecommend?: boolean;
  label?: string;
  price?: string;
};
const PlansCard: FC<PlansCardType> = ({
  isRecommend = false,
  label,
  price,
}) => {
  const theme = useTheme();

  return (
    <PlansCardStyled $isRecommend={isRecommend}>
      <div className="main-text">
        <div style={{ height: '57px' }}>
          <Typography
            style={{
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: '19.36px',
              marginTop: '30px',
              color: isRecommend
                ? theme.colors.white
                : theme.colors.landingSecondaryText,
            }}
          >
            {label}
          </Typography>
          {isRecommend && (
            <Typography className="recommend">Recommended</Typography>
          )}
        </div>
        <Typography
          style={{
            fontWeight: 600,
            fontSize: '30px',
            lineHeight: '45px',
            color: isRecommend ? theme.colors.white : theme.colors.primary,
          }}
        >
          € {price}{' '}
          <span
            style={{
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '25px',
              color: isRecommend ? theme.colors.white : theme.colors.darkText,
            }}
          >
            / Per Printout
          </span>
        </Typography>
        <Typography
          style={{
            color: isRecommend ? theme.colors.disable : theme.colors.darkText,
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '25px',
            textAlign: 'start',
          }}
        >
          For individuals and businesses with moderate printing needs
        </Typography>
      </div>
      <div className="merits">
        {data.map((merit, idx) => (
          <div className="merits-icon" key={idx}>
            <LiaCheckDoubleSolid
              color={
                isRecommend
                  ? theme.colors.white
                  : theme.colors.landingSecondaryText
              }
              size={16}
            />
            <Typography>{merit.label}</Typography>
          </div>
        ))}
      </div>
      <Button
        style={{
          width: '100%',
          backgroundColor: theme.colors.white,
          color: theme.colors.landingSecondaryText,
          border: isRecommend
            ? '1px solid white'
            : `1px solid ${theme.colors.landingSecondaryText}`,
          borderRadius: '20px',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '25px',
        }}
      >
        Get Started Now
      </Button>
    </PlansCardStyled>
  );
};

export default PlansCard;
